export interface ElementRectangle {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

export function getElementAbsolutePosition(el: Element) {
    const rect = el.getBoundingClientRect();
    return {
        top: rect.top + window.pageYOffset,
        right: rect.right + window.pageXOffset,
        bottom: rect.bottom + window.pageYOffset,
        left: rect.left + window.pageXOffset,
    };
}



// WEBPACK FOOTER //
// ./src/utility/DomUtils.ts